import { render, staticRenderFns } from "./addPersonStatic.vue?vue&type=template&id=69aa38ec&scoped=true&"
import script from "./addPersonStatic.vue?vue&type=script&lang=js&"
export * from "./addPersonStatic.vue?vue&type=script&lang=js&"
import style0 from "./addPersonStatic.vue?vue&type=style&index=0&id=69aa38ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69aa38ec",
  null
  
)

component.options.__file = "addPersonStatic.vue"
export default component.exports